module.exports = __webpack_public_path__ + "img/brandstory_info02_mobile.e0c86e89.png";